<template>
  <v-container class="pt-8 pb-0">
    <!-- Tamaño letra -->
    <v-row>
      <v-slider
        :label="t.mdd.tamanio"
        v-model="mdd.tam"
        min="1"
        max="5"
        step="1"
        ticks="always"
        tick-size="1"
      ></v-slider>
    </v-row>
    <v-row>
      <div class="hl-cont zoom">
        <div class="font-italic font-weight-bold primary--text">
          {{ t.mdd.tamEvang }}
        </div>
        <div>
          <p v-text="t.mdd.tamText"></p>
        </div>
      </div>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "user-libro-apariencia",
  props: ["mdd"],
  computed: {
    t() {
      return this.$store.getters["app/trad/activa"];
    }
  }
};
</script>
